import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
import messages from 'vee-validate/dist/locale/fr'

var options = {
    inject : false
};

var userLang = navigator.language || navigator.userLanguage;
userLang = userLang.toLowerCase();

if(['fr_fr', 'fr-fr', 'fr'].includes(userLang)){
    Validator.localize({ fr : messages });
    options.locale = 'fr';
}

Vue.use(VeeValidate, options);

export default VeeValidate;